import { TbUsers } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const usersRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.USERS,
        meta: {
            label: "users",
            order: 7,
            icon: TbUsers,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.AUTH_SVC_USER_LIST],
        },
    },
];
